import { render } from "./HeroiconsSolidArrowNarrowRight.vue?vue&type=template&id=df445764"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowRight.vue"]])

export default __exports__